export default "__VITE_ASSET__s9ft4iAH__"